import axios from 'axios';
import { ISeedDivider } from 'src/infrastructure/interfaces';

export default class SeedDividerService {

    static editSeedDivider(divider: ISeedDivider, formData: FormData) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/seedseparator/${divider.id}`,
                    formData,
                    { headers: {'Content-Type': 'multipart/form-data' }})
                .then((res) => {
                    resolve(res.data);
                })
                .catch(error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/SeedDividerService.ts